
const AlertNotistack = (status) => ({
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'center',
  },
  variant: status,
})

export default AlertNotistack